import {CompanyTypesWithCapital} from "@mytour/shared";
import {Field} from "@mytour/ui/form";
import {Splitter} from "@mytour/ui/layout";
import {useTranslation} from "react-i18next";
import {CompanyTypeSelect} from "./CompanyTypeSelect";
import type {Step1Props} from "./Step1";

/**
 * Feature-flag OFF variant — the onboarding identity form as it was before the
 * SIRET auto-fill feature (#158): every field visible, manual entry, no lookup.
 *
 * Kept deliberately self-contained: when the `siret-autofill` flag is retired,
 * either delete this file (feature promoted) or keep only this one (feature
 * dropped). It carries none of the auto-fill machinery.
 */
export function Step1ManualForm({hookForm, disabled}: Step1Props) {
  const {t: translate} = useTranslation();
  const companyType = hookForm.watch("companyType");

  return (
    <>
      <p style={{marginBottom: "8px"}}>
        <strong>{`Identité de l'entreprise`}</strong>
      </p>
      <Splitter>
        <CompanyTypeSelect hookForm={hookForm} />
        {CompanyTypesWithCapital.has(companyType) && (
          <Field
            required
            name="companyCapital"
            type="number"
            label={translate("myTourApp.platformUser.companyCapital")}
            hookForm={hookForm}
            disabled={disabled}
          />
        )}
      </Splitter>
      <Field
        required
        name="company"
        label={translate("myTourApp.platformUser.company")}
        hookForm={hookForm}
        disabled={disabled}
      />
      <Field
        required
        name="siret"
        label={translate("myTourApp.platformUser.siret")}
        hookForm={hookForm}
        disabled={disabled}
      />
      <Splitter width1={30} width2={68}>
        <Field
          required
          name="apeCode"
          label={translate("myTourApp.platformUser.apeCode")}
          hookForm={hookForm}
          disabled={disabled}
        />
        <Field
          required
          name="apeLabel"
          label={translate("myTourApp.platformUser.apeLabel")}
          hookForm={hookForm}
          disabled={disabled}
        />
      </Splitter>
    </>
  );
}
